// extracted by mini-css-extract-plugin
export var bubble = "_17-0";
export var container = "_17-f";
export var contrastBorder = "_17-g";
export var greyOut = "_17-2";
export var initialsColor0 = "_17-3";
export var initialsColor1 = "_17-4";
export var initialsColor10 = "_17-d";
export var initialsColor11 = "_17-e";
export var initialsColor2 = "_17-5";
export var initialsColor3 = "_17-6";
export var initialsColor4 = "_17-7";
export var initialsColor5 = "_17-8";
export var initialsColor6 = "_17-9";
export var initialsColor7 = "_17-a";
export var initialsColor8 = "_17-b";
export var initialsColor9 = "_17-c";
export var initialsWrapper = "_17-1";
export var large = "_17-l";
export var medium = "_17-k";
export var mediumSmall = "_17-j";
export var mediumSmallMedium = "_17-o";
export var micro = "_17-h";
export var small = "_17-i";
export var tiny = "_17-n";
export var xTiny = "_17-m";